import { action, observable } from 'mobx';
import { HttpClient, setMap } from 'Mri.Web.Common';

export class CloudConfigsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadAllAsync() {
        const cloudConfigs = await this.httpClient.get<Mri.CloudConfigs.CloudConfig[]>(`/api/v1/cloud-configs`);

        setMap(this.configs, cloudConfigs, d => d.cloudConfigGuid);
    }

    @action
    public async loadAsync(guid: string) {
        const config = await this.httpClient.get<Mri.CloudConfigs.CloudConfig>(`/api/v1/cloud-configs/${guid}`);

        if (config) this.configs.set(config.cloudConfigGuid, config);
    }

    @action
    public async createAsync(model: Mri.CloudConfigs.CloudConfig) {
        const config = await this.httpClient.post<Mri.CloudConfigs.CloudConfig>(`/api/v1/cloud-configs`, model);

        if (config) this.configs.set(config.cloudConfigGuid, config);
    }

    @action
    public async updateAsync(guid: string, model: Mri.CloudConfigs.CloudConfig) {
        const config = await this.httpClient.put<Mri.CloudConfigs.CloudConfig>(`/api/v1/cloud-configs/${guid}`, model);

        if (config) this.configs.set(config.cloudConfigGuid, config);
    }

    @action
    public async activateAsync(guid: string) {
        const config = await this.httpClient.put<Mri.CloudConfigs.CloudConfig>(`/api/v1/cloud-configs/${guid}/active`);

        if (config) this.configs.set(config.cloudConfigGuid, config);
    }

    @action
    public async deactivateAsync(guid: string) {
        const config = await this.httpClient.delete<Mri.CloudConfigs.CloudConfig>(
            `/api/v1/cloud-configs/${guid}/active`
        );

        if (config) this.configs.set(config.cloudConfigGuid, config);
    }

    @action
    public async loadStatusAsync(guid: string) {
        const configStatus = await this.httpClient.get<Mri.CloudConfigs.CloudConfigStatus>(
            `/api/v1/cloud-configs/${guid}/status`
        );

        if (configStatus) this.configStatuses.set(configStatus.cloudConfigGuid, configStatus);
    }

    @observable public configs = new Map<string, Mri.CloudConfigs.CloudConfig>();
    @observable public configStatuses = new Map<string, Mri.CloudConfigs.CloudConfigStatus>();

    private readonly httpClient: HttpClient;
}
